import { forwardRef } from 'react';
import { trans } from '@lingoda/i18n';
import { Link, Stack, Typography } from '@lingoda/ui';
import { WarningIcon } from '@lingoda/ui/icons/lingodaIcons';
import { platformInfo } from '@lingoda/user-agent';
import { NotificationBar } from './NotificationBar';

const getOsClockSettingsUrl = (): string | null => {
    const { osName } = platformInfo;

    if (osName === 'macOS') {
        return 'x-apple.systempreferences:com.apple.preference.datetime';
    }

    if (osName === 'Windows') {
        return 'ms-settings:dateandtime';
    }

    return null;
};

interface Props {
    onDismiss?: () => void;
    style?: React.CSSProperties;
}

export const InvalidLocalTimeBar = forwardRef<HTMLDivElement, Props>(
    ({ onDismiss, style }, ref) => {
        const clockSettingsUrl = getOsClockSettingsUrl();

        return (
            <NotificationBar
                ref={ref}
                severity="error"
                icon={<WarningIcon size={24} />}
                onDismiss={onDismiss}
                style={style}
            >
                <Stack direction="row" flexWrap="wrap" gap={1}>
                    <Typography
                        variant="subtitle1"
                        sx={{ color: (theme) => theme.colors.text.danger }}
                    >
                        {trans('invalid-device-time-detected', {}, 'alerts-common+intl-icu')}
                    </Typography>
                    {clockSettingsUrl && (
                        <Link href={clockSettingsUrl}>
                            {trans(
                                'invalid-device-time-detected.open-settings',
                                {},
                                'alerts-common+intl-icu',
                            )}
                        </Link>
                    )}
                </Stack>
            </NotificationBar>
        );
    },
);

InvalidLocalTimeBar.displayName = 'InvalidLocalTimeBar';
